var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"pa-0",staticStyle:{"background-color":"#FAFAFA"}},[_c('router-view'),_c('snack',{attrs:{"type":_vm.alertType,"text":_vm.alertText,"show":_vm.showAlert,"closeManual":_vm.closeManual}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }